var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73828 16.2441H22.2368",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73828 20.7725H22.2368",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73828 25.3018H22.2368",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73828 29.8301H22.2368",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73828 36.4668H14.0087",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1469_7692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44V44H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1469_7692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1048 8.78184H14.9874C14.5455 8.78184 14.1872 8.42357 14.1872 7.98159V5.89039C14.1872 5.44841 14.5455 5.09014 14.9874 5.09014H28.219C28.661 5.09014 29.0192 5.44841 29.0192 5.89039V7.98159C29.0192 8.42357 28.661 8.78184 28.219 8.78184H19.1178M34.4825 32.5V3.19075C34.4825 1.78559 33.3434 0.646484 31.9382 0.646484H10.0725C9.39773 0.646484 8.75054 0.91461 8.27341 1.39174L1.62847 8.03668C1.15134 8.5138 0.883301 9.16091 0.883301 9.83569V40.8132C0.883301 42.2183 2.0224 43.3574 3.42748 43.3574H31.9382C33.3434 43.3574 34.4825 42.2183 34.4825 40.8132V39.9453",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01858 0.874485V7.20387C9.01858 8.0751 8.31235 8.78125 7.44128 8.78125H1.11182",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertification);
export default __webpack_public_path__ + "static/media/icon-certification.950d695906c3a9770b233ef6b07c7ad3.svg";
export { ForwardRef as ReactComponent };